import React, { useState } from 'react';
import styled from 'styled-components';
import closeModal from '../../../icons/close_modal.svg';
import { PortfolioSubNavMobile } from './PortfolioSubNavMobile';

const StyledBurger = styled.div`
  width: 1rem;
  height: 1.5rem;
  position: fixed;
  top: 14px;
  right: 20px;
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;
  div {
    width: 1.5rem;
    height: 0.15rem;
    background-color: #333;
    border-radius: 10px;
  }
` 

const CloseBurger = styled.img`
  padding-right: 10px;
`
const BurgerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width:50%;
`

export const Burger = () => {
  const [open, setOpen] = useState(false);
  const toggleNav = () => {
    window.scrollTo(0, 0);
    setOpen(!open);
  }

  return (
    <BurgerWrapper>
      {
        !open ? (
          <StyledBurger open={open} onClick={()=> setOpen(!open)}>
            <div />
            <div />
            <div />
          </StyledBurger>
        ):
          <>
            <CloseBurger onClick={()=> setOpen(!open)} src={closeModal} width='30px' height='30px' alt='close-nav' />
          </>
      }
      <PortfolioSubNavMobile open={open} onChangeSection={toggleNav} />
    </BurgerWrapper>
  )
}

